import React from 'react'
import { LockOutlined } from '@ant-design/icons'
import { Space, Tooltip } from 'antd'
import { includes, isEqual, map } from 'lodash'

import { STATUS_FLAG_FIELD } from '../../common/constants'

import { MENU_CURATION_TASK_STATUS } from '../../menu-curation-tasks/constants'
import DishTableCheckAllColumn from '../components/sections/dish-table-check-all-column'
import DishTableStatusCheckbox from '../components/sections/dish-table-status-checkbox'
import DishTableTierOneStatusCheckbox from '../components/sections/dish-table-tier-one-status-checkbox'
import { DISH_FIELDS_CONFIG } from '../constants'
import { computeDishRowDisabled } from '../helpers'

import createDishTableCellContent from './create-dish-table-cell-content'

const createDishTableColumns = ({
  availableDishFields,
  taskStatus,
  isTaskTierOneDone,
  isDisabled,
  dishes,
  allergenOptions,
  dietOptions,
  treeTypeOptions,
  ingredientOptions,
  isMenuFake,
  forceShouldCellUpdate,
}) => [
  {
    key: 'validate',
    title: includes(
      [
        MENU_CURATION_TASK_STATUS.CURATION_IN_PROGRESS.value,
        MENU_CURATION_TASK_STATUS.QA_IN_PROGRESS.value,
        MENU_CURATION_TASK_STATUS.QC_IN_PROGRESS.value,
      ],
      taskStatus,
    ) && (
      <DishTableCheckAllColumn
        dishes={dishes}
        taskStatus={taskStatus}
        isDisabled={isDisabled}
      />
    ),
    width: '50px',
    fixed: 'left',
    render: ({
      id,
      isTierOneDone,
      isCurationDone,
      isQaDone,
      isQcDone,
      isLocked,
    }) => {
      if (isLocked) {
        return (
          <Tooltip title="This dish is locked.">
            <LockOutlined />
          </Tooltip>
        )
      }

      if (taskStatus === MENU_CURATION_TASK_STATUS.TIER_ONE_IN_PROGRESS.value) {
        return (
          <Space>
            <DishTableTierOneStatusCheckbox
              dishId={id}
              value={isTierOneDone}
              tooltip="Set dish tier one done"
              statusFlagFieldName={STATUS_FLAG_FIELD.IS_TIER_ONE_DONE}
              isDisabled={isDisabled || isTaskTierOneDone}
            />
          </Space>
        )
      }

      if (
        includes(
          [
            MENU_CURATION_TASK_STATUS.CURATION_IN_PROGRESS.value,
            MENU_CURATION_TASK_STATUS.QA_IN_PROGRESS.value,
          ],
          taskStatus,
        )
      ) {
        return (
          <Space>
            <DishTableStatusCheckbox
              dishId={id}
              value={isCurationDone}
              tooltip="Set dish curation done"
              statusFlagFieldName={STATUS_FLAG_FIELD.IS_CURATION_DONE}
              isDisabled={
                isDisabled ||
                taskStatus === MENU_CURATION_TASK_STATUS.QA_IN_PROGRESS.value
              }
            />
            <DishTableStatusCheckbox
              dishId={id}
              value={isQaDone}
              tooltip="Set dish qa done"
              statusFlagFieldName={STATUS_FLAG_FIELD.IS_QA_DONE}
              isDisabled={
                isDisabled ||
                taskStatus ===
                  MENU_CURATION_TASK_STATUS.CURATION_IN_PROGRESS.value
              }
            />
          </Space>
        )
      }

      if (taskStatus === MENU_CURATION_TASK_STATUS.QC_IN_PROGRESS.value) {
        return (
          <Space>
            <DishTableStatusCheckbox
              dishId={id}
              value={isQaDone}
              tooltip="Set dish qa done"
              statusFlagFieldName={STATUS_FLAG_FIELD.IS_QA_DONE}
              isDisabled
            />
            <DishTableStatusCheckbox
              dishId={id}
              value={isQcDone}
              tooltip="Set dish qc done"
              statusFlagFieldName={STATUS_FLAG_FIELD.IS_QC_DONE}
              isDisabled={isDisabled}
            />
          </Space>
        )
      }

      return null
    },
  },
  ...map(availableDishFields, field => ({
    key: DISH_FIELDS_CONFIG[field].value,
    dataIndex: DISH_FIELDS_CONFIG[field].value,
    title: DISH_FIELDS_CONFIG[field].label,
    fixed: DISH_FIELDS_CONFIG[field].columnFixedPosition,
    width: DISH_FIELDS_CONFIG[field].columnWidth,
    shouldCellUpdate: (prev, next) =>
      forceShouldCellUpdate || !isEqual(prev, next),
    render: (_, dish, index) =>
      createDishTableCellContent({
        dish,
        index,
        field: DISH_FIELDS_CONFIG[field].value,
        isFieldEditable: DISH_FIELDS_CONFIG[field].isEditable,
        isDisabled: computeDishRowDisabled({
          dish,
          taskStatus,
          isTaskDisabled: isDisabled,
        }),
        allergenOptions,
        dietOptions,
        treeTypeOptions,
        ingredientOptions,
        isMenuFake,
      }),
  })),
]

export default createDishTableColumns
